(function() {
  'use strict';
  angular.module('benefits')
    .filter('procedures',['$filter', function($filter) {
      return function(procedures) {
        if(!procedures) {
          return "";
        } else {
          var proceduresFrom = $filter('procedureCode')(procedures.from);
          var proceduresTo = $filter('procedureCode')(procedures.to);
          return proceduresFrom + ( proceduresFrom !== proceduresTo ? ((procedures.codes.length < 3) ? ", " + proceduresTo : "-" + proceduresTo) : "");
        }
      };
    }]);
})();
